import type { DeviceMode } from "../../model/types";

/**
 * Брейкпоинты MUI считаются от ширины окна, а не контейнера, поэтому внутри
 * узкой рамки превью на широком экране мобильный режим через useMediaQuery не
 * получить. Везде, где витрина ветвится по sm/md, здесь ветвление по device:
 * mobile повторяет значение витрины на xs, desktop - на md.
 */
export function byDevice<T>(
  device: DeviceMode,
  values: { mobile: T; desktop: T }
): T {
  return device === "mobile" ? values.mobile : values.desktop;
}
